import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForTwcSkuRecommendation(context: EditionAwarenessContextType): boolean {
	const { edition, product, isInCollection, hasPaymentDetailsEntered } = context;

	return Boolean(
		isEditionOneOf(edition, ['free']) &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		isInCollection === 'NOT_IN_COLLECTION' &&
		!hasPaymentDetailsEntered &&
		fg('twc-sku-optimisation-shadow'),
	);
}
